//日期格式转化
function formatDate(time) {
    //console.log(timew)
    var char = "-";
    var date = new Date(time)
    var day = date.getDate();
    var month = date.getMonth() + 1; //注意月份需要+1
    var year = date.getFullYear();
    //补全0，并拼接
    var currentdate = year + char + (month < 10 ? "0" + month : month) + char + (day < 10 ? "0" + day : day);
    return currentdate
}

//日期格式转化(日月年时分秒)
function formatDateTime(time) {
    //console.log(timew)
    var char = "-";
    var date = new Date(time)
    var day = date.getDate();
    var month = date.getMonth() + 1; //注意月份需要+1
    var year = date.getFullYear();
    var hour = date.getHours()
        // hour = checkAddZone(hour)
    var min = date.getMinutes()
        // min = checkAddZone(min)
    var se = date.getSeconds()
        // se = checkAddZone(se)
        //补全0，并拼接
    var currentdate = year + char + (month < 10 ? "0" + month : month) + char + (day < 10 ? "0" + day : day) + ' ' + hour + ':' + min + ':' + se;
    return currentdate
}

//生日换算
function age(strBirthday) {
    var returnAge, d;
    var strBirthdayArr = strBirthday.split("-");
    var birthYear = strBirthdayArr[0];
    var birthMonth = strBirthdayArr[1];
    var birthDay = strBirthdayArr[2];

    d = new Date();
    var nowYear = d.getFullYear();
    var nowMonth = d.getMonth() + 1;
    var nowDay = d.getDate();

    if (nowYear == birthYear) {
        returnAge = 0; //同年 则为0岁
    } else {
        var ageDiff = nowYear - birthYear; //年之差
        if (ageDiff > 0) {
            if (nowMonth == birthMonth) {
                var dayDiff = nowDay - birthDay; //日之差
                if (dayDiff < 0) {
                    returnAge = ageDiff - 1;
                } else {
                    returnAge = ageDiff;
                }
            } else {
                var monthDiff = nowMonth - birthMonth; //月之差
                if (monthDiff < 0) {
                    returnAge = ageDiff - 1;
                } else {
                    returnAge = ageDiff;
                }
            }
        } else {
            returnAge = -1; //返回-1 表示出生日期输入错误 晚于今天
        }
    }

    return returnAge; //返回周岁年龄

}

//提取数组id转化
function deveridarrry(arr) {
    if (typeof(arr) != "undefined" && arr != null) {
        let array = []
        for (var i = 0; i < arr.length; i++) {
            array.push(parseInt(arr[i]))
        }
        return JSON.stringify(array)
    } else {
        return []
    }
}


/** 图片压缩，默认同比例压缩
 *  图片对象
 *  回调函数有一个参数，base64的字符串数据
 */
function compress(fileObj, callback) {  
    try {    
        const image = new Image();    
        image.src = URL.createObjectURL(fileObj);    
        image.onload = function() {      
            const that = this       // 默认按比例压缩
                      
            let w = that.width;      
            let h = that.height;      
            const scale = w / h;      
            w = fileObj.width || w;      
            h = fileObj.height || (w / scale);      
            let quality = 0.7 // 默认图片质量为0.7
                       // 生成canvas
                      
            const canvas = document.createElement('canvas');      
            const ctx = canvas.getContext('2d');       // 创建属性节点
                  
            const anw = document.createAttribute('width');      
            anw.nodeValue = w;      
            const anh = document.createAttribute('height');      
            anh.nodeValue = h;      
            canvas.setAttributeNode(anw);      
            canvas.setAttributeNode(anh);      
            ctx.drawImage(that, 0, 0, w, h);       // 图像质量
                  
            if (fileObj.quality && fileObj.quality <= 1 && fileObj.quality > 0) {         quality = fileObj.quality       }       // quality值越小，所绘制出的图像越模糊
                  
            const data = canvas.toDataURL('image/jpeg', quality);       // 压缩完成执行回调
                  
            const newFile = convertBase64UrlToBlob(data);      
            callback(newFile);    
        }  
    } catch (e) {     console.log('压缩失败!')   }
}

function convertBase64UrlToBlob(urlData) {  
    const bytes = window.atob(urlData.split(',')[1]) // 去掉url的头，并转换为byte
           // 处理异常,将ascii码小于0的转换为大于0
           const ab = new ArrayBuffer(bytes.length);  
    const ia = new Uint8Array(ab);  
    for (let i = 0; i < bytes.length; i++) {     ia[i] = bytes.charCodeAt(i)   }  
    return new Blob([ab], { type: 'image/png' })
}

// 暴露出这些属性和方法
export default {
    formatDate,
    formatDateTime,
    age,
    deveridarrry,
    compress,
}


// WEBPACK FOOTER //
// ./src/assets/publicJS/public.js